
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Number of milliseconds in a second.
*
* @module @stdlib/constants/time/milliseconds-in-second
* @type {integer32}
*
* @example
* var MILLISECONDS_IN_SECOND = require( '@stdlib/constants/time/milliseconds-in-second' );
* // returns 1000
*/


// MAIN //

/**
* The number of milliseconds in a second.
*
* @constant
* @type {integer32}
* @default 1000
*/
var MILLISECONDS_IN_SECOND = 1000|0; // asm type annotation


// EXPORTS //
export default MILLISECONDS_IN_SECOND;
